import { trackUserEvent } from '../analytics';
import { getZrmUserInfo } from '@zg-rentals/clickstream';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const BLOCKED_USER_MODAL_TRIGGER_OBJECTS = {
  VERIFY_ACCOUNT: 'verify_your_account',
  VERIFICATION_ACCOUNT: 'verification_of_your_account',
  CONTACT_SUPPORT_TEAM: 'contact_our_support_team',
  CONTACT_SUPPORT: 'contact_support',
  RETURN_TO_ZILLOW: 'return_to_zillow',
} as const;

// https://dataportal.zillowgroup.net/event-registry/7541
export const emitViewBlockedUserModalEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '7541',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'impression',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_blocked_user_modal',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_account_verification'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7542
export const emitClickContactSupportEvent = ({
  user,
  triggerObject,
}: {
  user: ZrmClickstreamUser;
  triggerObject: (typeof BLOCKED_USER_MODAL_TRIGGER_OBJECTS)[keyof typeof BLOCKED_USER_MODAL_TRIGGER_OBJECTS];
}) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '7542',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: 'link_to_contact_support_blocked_modal',
    },
    semantic: {
      semantic_event_nm: 'click_contact_support',
      topic_tag_txt: ['zrm_account_verification'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7543
export const emitClickReturnToZillowEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '7543',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'return_to_zillow',
      trigger_source_nm: 'cta_return_to_zillow',
    },
    semantic: {
      semantic_event_nm: 'click_cta_return_to_zillow',
      topic_tag_txt: ['zrm_account_verification'],
    },
    ...getZrmUserInfo(user),
  });
